module.exports = __webpack_public_path__ + "img/110080.2544da69.png";